import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { store } from 'store/index'
import { Button } from 'src/design-system'
import * as SecondaryNav from 'components/secondary-nav'

type NavProps = {
  defaultOpen?: boolean
  onRefresh?: () => void
}

export const Nav = observer((props: NavProps) => {
  const canImportPositions = !!store.currentUser && store.currentUser.isAdmin
  const downloadLink = `/orgs/${store.currentUser?.org?.slug}/positions/download.csv`

  return (
    <SecondaryNav.Root>
      <div className="flex items-center justify-between w-full">
        <SecondaryNav.Header>Positions</SecondaryNav.Header>
        {canImportPositions && (
          <Button
            as="a"
            href="/position_imports/new"
            variant="outline"
            colourVariant="subtle"
            size="nav"
            data-turbo-action="advance"
          >
            Import and sync
          </Button>
        )}
      </div>
    </SecondaryNav.Root>
  )
})
